import React from 'react';

export function WithdrawIcon() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3335 5.33325C13.3335 6.25373 12.5873 6.99992 11.6668 6.99992C10.7464 6.99992 10.0002 6.25373 10.0002 5.33325C10.0002 4.41278 10.7464 3.66658 11.6668 3.66658C12.5873 3.66658 13.3335 4.41278 13.3335 5.33325Z" fill="black" />
      <path d="M19.1668 0.333252H4.16683L4.16683 10.3333L19.1668 10.3333V0.333252ZM17.5002 8.66659L5.8335 8.66658L5.8335 1.99992L17.5002 1.99992V8.66659Z" fill="black" />
      <path d="M0.833496 2.83325V13.6666H16.6668V11.9999H2.50016V2.83325H0.833496Z" fill="black" />
    </svg>
  );
}
